export default class TagDestinationCandidate {
  constructor(id, name, recruitersCount) {
    this.id = parseInt(id, 10) || null
    this.name = name
    this.recruitersCount = recruitersCount
  }

  static fromJson(json) {
    return new TagDestinationCandidate(json.id || null, json.name || null, json.recruiters_count || 0)
  }
}
